import ArticleBoxCube from './articleBoxCube';

export default ArticleBoxCube;
